import { get } from '@/common/request';

const positionMap = new Map([
  ['search', '/position/search']

]);

export default positionMap;

export function userSearch(params:any): Promise<any> {
  return get('/position/search', { ...params }, { proxyApi: '/mirage', needHint: true });
}

/**
 * 岗位列表
 * https://yapi.lanhanba.com/project/317/interface/api/33585
 */

export async function positionList(params?: any) {
  return get('/position/list', { ...params }, { proxyApi: '/mirage', needHint: true });
}
